// extracted by mini-css-extract-plugin
export var auto = "_2s-1";
export var spinner = "_2s-0";